import React from 'react';

import { ProgressBar } from './ProgressBar';
import { Logo } from 'js/app/components/common/Logo';

import { useSetStatusAfterLoading } from '../hooks/useSetStatusAfterLoading';

import style from '../JumioPopupUploader.scss';

export const JumioStepLoading = ({
    isSimple,
    translate,
    verificationTimeout,
    setCurrentStep,
    handlerAfterPassed,
    setVerificationPassed
}) => {
    useSetStatusAfterLoading({
        isSimple,
        setCurrentStep,
        handlerAfterPassed,
        setVerificationPassed,
        timeout: verificationTimeout
    });

    return (
        <div className="id-verification id-verification__result">
            <div className="id-verification__result_message">
                {translate('please-wait-for-jumio')}
            </div>

            <Logo size='10rem' className={style.logo} />

            <ProgressBar verificationTimeout={verificationTimeout} />
        </div>
    );
};
